/* eslint-disable */
import { useEffect, useRef, useState } from 'react';
import { motion } from 'framer-motion';
import { Header, Container, ExportReportWrapper } from '../../styles/shared/styles';
import Box from '@material-ui/core/Box';
import IndicationManagerReportTableList from '../../components/IndicationManagerReportTableList';
import DatePeriodFilter from '../../components/IndicationManagerReportTableList/Filter';
import SummaryReport from '../../components/IndicationManagerReportTableList/SummaryReport';
import useApp from '../../hooks/useApp';
import useSWR from 'swr';
import { TablePagination } from '@material-ui/core';
import { DateTime } from 'luxon';
import { listToMatrix } from '../../utils/array';
import { excelExport } from '../../service/excel.service';
import { fetcher, variantFetcher } from '../../service/SWRFetcher';

const InidicationManagerReport = () => {
  const ref = useRef(null);

  const { setState } = useApp();

  const [pages, setPages] = useState({
    per_page: 10,
    page: 0,
  });

  const [reportFilter, setReportFilter] = useState({
    date_ini: DateTime.now().plus({ months: -1 }).toISODate(),
    date_end: DateTime.now().toISODate(),
    partners: [],
    insurance_id: [],
    broker: [],
  });

  const handleChangePage = (event, newPage) => {
    setPages({ ...pages, page: newPage });
  };

  const handleChangeRowsPerPage = (event) => {
    setPages({ ...pages, page: 0, per_page: parseInt(event.target.value, 10) });
  };

  const { data, mutate, isValidating } = useSWR(
    `/leads/indicationManagerReport?page=${pages?.page}&per_page=${pages?.per_page}&date_ini=${reportFilter.date_ini}&date_end=${reportFilter.date_end}&partners=${reportFilter?.partners}&insurance_id=${reportFilter?.insurance_id}&broker=${reportFilter?.broker}`,
    variantFetcher,
    { revalidateOnFocus: false }
  );

  useEffect(() => {
    if (pages.page) {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }

    if (pages.per_page > 10) {
      ref?.current?.scrollIntoView({ behavior: 'smooth' });
    }
  }, [pages, isValidating]);

  useEffect(() => {
    setState('loading', isValidating);
  }, [isValidating]);

  return (
    <motion.div initial={{ opacity: 0, x: -100 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -100 }}>
      <Container style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
        <Header>
          <h1>Relatório de Indicação (Corretora)</h1>
        </Header>

        <DatePeriodFilter corretora filtersParams={reportFilter} setFiltersParams={setReportFilter} />

        <SummaryReport listItem={data?.summaryReport} title="Relatório de Indicação (Gerência) - Resumo" />

        {data?.summaryReport && data?.summaryReport?.length > 0 && (
          <ExportReportWrapper>
            <button
              className="button"
              onClick={() =>
                excelExport(
                  `/leads/summaryReportExport?date_ini=${reportFilter.date_ini}&date_end=${reportFilter.date_end}&partners=${reportFilter?.partners}&insurance_id=${reportFilter?.insurance_id}&broker=${reportFilter?.broker}`,
                  'resumo_relatorio_indicação_' + DateTime.now().toFormat('dd_LL_yyyy')
                )
              }>
              Exportar
            </button>
          </ExportReportWrapper>
        )}

        <TablePagination
          ref={ref}
          component="div"
          count={data?.meta?.total || 0}
          page={pages.page || 0}
          onPageChange={handleChangePage}
          rowsPerPage={pages.per_page || 0}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />

        <IndicationManagerReportTableList listItem={data?.data} title="Relatório de Indicação (Gerência)" />

        {data?.data && data?.data?.length > 0 && (
          <ExportReportWrapper>
            <button
              className="button"
              onClick={() =>
                excelExport(
                  `/leads/indicationManagerReportExport?date_ini=${reportFilter.date_ini}&date_end=${
                    reportFilter.date_end
                  }&partners=${reportFilter?.partners}&insurance_id=${reportFilter?.insurance_id}&broker=${reportFilter?.broker}`,
                  'relatorio_indicação_' + DateTime.now().toFormat('dd_LL_yyyy')
                )
              }>
              Exportar
            </button>
          </ExportReportWrapper>
        )}
      </Container>
    </motion.div>
  );
};

export default InidicationManagerReport;
